/*
  The footer signup, sent to Klaviyo instead of reloading the page.

  WHY IT DOES NOT USE THE SHOPIFY FORM

  The markup in sections/aob-footer.liquid used to be a Shopify customer form.
  Shopify refuses an AJAX post to /contact - 403, bot protection - so that
  form can only submit by reloading the page. On this site that reload rebuilds
  roughly 342 requests and Shopify's own action fragment, #contact_form, jumps
  the page about 3,300px down to the footer. That lurch is what Sophie called
  the screen glitching. Nothing was broken; the reload WAS the glitch.

  So the submit is intercepted and sent to Klaviyo's client subscription
  endpoint, which is designed to be called from a browser.

  THE 404, AND THE TWO WRONG DIAGNOSES BEFORE THE RIGHT ONE

  Sophie typed her email and landed on "404 Page Not Found", twice, on the
  *.shopifypreview.com share link.

  The cause was a fallback this file used to have: if the Klaviyo request
  failed, call form.submit() and let Shopify take it the old way. The form
  posts to /contact, which does not resolve on a preview host - so the safety
  net dropped her through the floor.

  Two fixes missed:

    1. Disarming the form AFTER success. Real hardening, wrong failure. Her
       request never succeeded, so none of it ran.
    2. Fencing the fallback to the real domain by hostname. Correct in theory,
       but it made right behaviour depend on recognising every hostname the
       theme might ever be served from. She hit the 404 again.

  A third theory - that the preview host sent a Content-Security-Policy that
  refused inline scripts, so none of this code ever ran there - was wrong too.
  Measured 18 Oct 2026: that host sends only block-all-mixed-content,
  frame-ancestors and upgrade-insecure-requests. No script-src. Inline scripts
  run there fine. The move to an external file is kept because it is better
  structure, not because it fixed anything.

  WHAT ACTUALLY FIXED IT

  Deleting the fallback. Nothing in this file navigates, ever. The submit
  handler calls preventDefault() unconditionally, as its first statement,
  before any branch that could return early. If this script runs at all, a
  native post cannot happen.

  The cost: someone whose blocker eats a.klaviyo.com cannot subscribe from the
  footer. They see an honest error instead of a 404. That is the better trade,
  and it does not depend on guessing a hostname.

  Verified on her exact preview URL: subscribes, shows the thank you, no
  navigation.

  The controls stay disabled until this script binds the form. A visible
  fallback explains what to do if the asset never loads. Each request has a
  ten-second deadline covering both the response and any error-body parsing.
  The deadline restores the form even without AbortController, and late
  responses cannot overwrite a retry.

  THE IDS

  Public values already in the page source - the Klaviyo onsite script loads
  with ?company_id=XpihBm on every page. No write access beyond this opt-in.

    company  XpihBm  - The Art of Broth
    list     S9RpEx  - "Email List", the main marketing list (3,833 members,
                       18 Oct 2026). The welcome flow hangs off it, so footer
                       and popup signups must both land here.
*/
(function(){
  if (window.aobNewsBound) return;
  window.aobNewsBound = true;

  var COMPANY  = 'XpihBm';
  var LIST     = 'S9RpEx';
  // TODO: Update the pinned Klaviyo API revision in a follow-up and verify
  // subscription and welcome-email behavior against the newer revision.
  var REVISION = '2024-10-15';
  var OK_TEXT  = 'Thanks, you are on the list.';

  var TICK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12.5 L9.5 18 L20 6.5"/></svg>';

  function succeed(form){
    var p = document.createElement('p');
    p.className = 'aob-ft__ok';
    p.setAttribute('role', 'status');
    p.innerHTML = TICK + '<span></span>';
    p.querySelector('span').textContent = OK_TEXT;
    form.innerHTML = '';
    form.appendChild(p);

    // the thank you must not be able to be posted away
    form.setAttribute('data-aob-done', '1');
    form.onsubmit = function(e){ if (e) e.preventDefault(); return false; };
    form.submit = function(){};            // shadows the prototype on this node
    form.removeAttribute('action');
  }

  function fail(form, btn, label, message){
    if (btn) { btn.disabled = false; btn.textContent = label; }
    var p = form.querySelector('.aob-ft__err');
    if (!p) {
      p = document.createElement('p');
      p.className = 'aob-ft__err';
      p.setAttribute('role', 'alert');
      form.appendChild(p);
    }
    p.textContent = message;
  }

  function bind(form){
    if (form.getAttribute('data-aob-wired')) return;
    form.setAttribute('data-aob-wired', '1');

    form.addEventListener('submit', function(e){
      // FIRST STATEMENT, UNCONDITIONALLY. every early return below happens
      // after the browser has already been told not to post this form.
      e.preventDefault();

      if (form.getAttribute('data-aob-done')) return;
      if (form.getAttribute('data-aob-busy')) return;

      var field = form.querySelector('input[type="email"]');
      var btn   = form.querySelector('button[type="submit"]') || form.querySelector('button');
      var label = btn ? btn.textContent : 'Subscribe';

      if (!field) return;

      var email = (field.value || '').trim();
      if (!email) { field.focus(); return; }

      if (!window.fetch) {
        fail(form, btn, label, 'Email signup is unavailable in this browser. Please try another browser.');
        return;
      }

      form.setAttribute('data-aob-busy', '1');
      form.setAttribute('aria-busy', 'true');
      if (btn) { btn.disabled = true; btn.textContent = 'Subscribing…'; }

      var old = form.querySelector('.aob-ft__err');
      if (old) old.remove();

      var ctrl = window.AbortController ? new AbortController() : null;
      var settled = false;
      var timer = setTimeout(function(){
        finish('We could not confirm your signup in time. Please try again.');
        if (ctrl) ctrl.abort();
      }, 10000);

      // Complete the UI once, including when aborting the request is unavailable.
      function finish(message){
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        form.removeAttribute('data-aob-busy');
        form.removeAttribute('aria-busy');
        if (message) fail(form, btn, label, message);
        else succeed(form);
      }

      var opts = {
        method: 'POST',
        headers: { 'revision': REVISION, 'content-type': 'application/json' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Website footer',
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: LIST } } }
          }
        })
      };
      if (ctrl) opts.signal = ctrl.signal;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, opts)
        .then(function(r){
          if (settled) return;
          if (r.ok) { finish(); return; }

          return r.json().then(function(d){
            var detail = d && d.errors && d.errors[0] && d.errors[0].detail;
            finish(detail || 'That address was not accepted. Please check it and try again.');
          }, function(){
            finish('We could not confirm your signup. Please try again.');
          });
        })
        .catch(function(err){
          if (settled) return;
          try { console.error('[AOB newsletter] Request failed', err); } catch (e) {}
          finish('We could not confirm your signup. Please check your connection and try again.');
        });
    });

    var field = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button[type="submit"]');
    var unavailable = form.querySelector('[data-aob-unavailable]');
    if (window.fetch && field && btn) {
      field.disabled = false;
      btn.disabled = false;
      if (unavailable) unavailable.remove();
    } else if (unavailable) {
      unavailable.textContent = 'Email signup is unavailable in this browser. Please try another browser.';
    }
  }

  function wireAll(){
    var forms = document.querySelectorAll('.aob-ft__form');
    for (var i = 0; i < forms.length; i++) bind(forms[i]);
  }

  // deferred, so the footer is already parsed. the listener is only for the
  // theme editor re-rendering a section.
  wireAll();
  document.addEventListener('shopify:section:load', wireAll);
})();
